<template>
  <div class="addressList">
    <Header
      :headerTitle="$t('m.addressList.title')"
      :hasBackBtn="false"
    ></Header>
    <div class="search">
      <div class="searchImage">
        <img src="../../assets/img/search.png" />
      </div>
      <input
        type="text"
        :placeholder="$t('m.addressList.placeholderCity')"
        @change="descInput()"
        @input="descInput()"
        v-model="addressSerach"
      />
      <span @click="backBtnClick">{{ $t("m.addressList.cancel") }}</span>
    </div>
    <section class="address-content" v-if="addressList != ''">
      <p class="currentCity">
        {{ $t("m.addressList.currentCity") }}:
        <span
          @click="
            cityItemData(currentCity.enName, currentCity.name, currentCity.id)
          "
          >{{
            $i18n.locale === "zh_CN" ? currentCity.name : currentCity.enName
          }}</span
        >
      </p>
      <dl v-for="(item, index) in addressList" :key="index">
        <dt v-show="cityEnameShow">{{ index }}</dt>
        <dd
          v-for="(cityItem, indexs) in addressList[index]"
          :key="indexs"
          @click="cityItemData(cityItem.enName, cityItem.name, cityItem.id)"
        >
          {{ $i18n.locale === "zh_CN" ? cityItem.name : cityItem.enName }}
        </dd>
      </dl>
    </section>
    <div class="no-address-content" v-if="emptyAddressFlag">
      <img src="../../assets/img/noneSearch.png" />
      <p>{{ $t("m.addressList.noResult") }}</p>
    </div>
  </div>
</template>
<script scoped>
import { getCityList } from "../../api/address.js";
import { setCookie, getCookie } from "../../utils/CookieUtil.js";

export default {
  name: "AddressList",
  data() {
    return {
      addressSerach: "",
      addressList: {}, //所择城市
      currentCity: {}, //当前城市
      emptyAddressFlag: false,
      cityEnameShow: true,
    };
  },
  watch: {
    addressSerach(newVal, oldVal) {
      this.getCityListData();
    }
  },
  methods: {
    backBtnClick() {
      window.history.back();
    },
    cityItemData(enName, name, id) {
      setCookie("cityItemId", id);
      setCookie("cityItemName", name);
      setCookie("cityItemEnName", enName);
      this.$router.back(-1);
    }, //监听搜索数据
    descInput: function() {
      this.getCityListData();
    },
    getCityListData() {
      let param = {
        cityName: this.addressSerach,
      };
      if (sessionStorage.getItem("c")) {
        param["c"] = sessionStorage.getItem("c");
      }

      getCityList(param).then((response) => {
        if (response.data.status === 200) {
          this.addressList = response.data.result;
          this.emptyAddressFlag = Object.keys(this.addressList).length <= 0;
        } else {
          this.emptyAddressFlag = false;
        }
      });
    },
  },
  
  created() {
    this.getCityListData();
    this.currentCity = this.$route.params.currentCity;
    if (sessionStorage.getItem("c")) {
      this.cityEnameShow = false;
    }
  },
  mounted(){
    this.getCityListData();
  }
};
</script>
<style scoped>
.addressList {
  margin-top: 12px;
  width: 100%;
}

.addressList .search {
  margin: 0 5%;
  width: 90%;
  line-height: 35px;
  vertical-align: middle;
}

.addressList .search .searchImage {
  position: absolute;
  left: 7%;
  width: 10%;
}

.addressList .search img {
  width: 65%;
}

.addressList .search input {
  border: 0;
  width: 83%;
  background-color: #efefef;
  border-radius: 6px;
  padding-left: 15%;
  font-size: 0.9rem;
}

.addressList .search span {
  margin-left: 6%;
  display: inline-block;
  width: 11%;
  font-size: 0.9rem;
}

.addressList .address-content {
  margin: 0;
  text-align: left;
  margin-top: 8px;
}

.addressList .address-content dl {
  margin-bottom: 0;
}

.addressList .address-content dl dt {
  background-color: #f0efed;
  padding: 5px 4%;
}

.addressList .address-content dl dd {
  line-height: 40px;
  padding: 0 4%;
}

.addressList .address-content .currentCity {
  padding: 8px 4%;
  background-color: #f0efed;
}

.addressList .address-content .currentCity span {
  color: #0066b1;
}

.addressList .no-address-content {
  margin: 0 auto;
}

.addressList .no-address-content img {
  width: 40%;
  margin-top: 100px;
}

.addressList .no-address-content p {
  color: #666;
  margin-top: -6px;
  font-family: 黑体;
  font-size: 14px;
}
</style>
